(function () {
  function visibleCount() {
    var w = window.innerWidth;
    if (w <= 649) return 3;
    if (w <= 989) return 3;
    return 5;
  }

  function init(root) {
    var viewport = root.querySelector('.moyshop-home-meaning__viewport');
    var track = root.querySelector('[data-mhm-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-mhm-slide]'));
    var prev = root.querySelector('[data-mhm-prev]');
    var next = root.querySelector('[data-mhm-next]');
    if (!viewport || !track || slides.length === 0) return;

    var index = 0;
    var total = slides.length;

    function maxStart(vis) {
      return Math.max(0, total - vis);
    }

    function wrapStart(i, vis) {
      var max = maxStart(vis);
      if (max === 0) return 0;
      if (i < 0) return max;
      if (i > max) return 0;
      return i;
    }

    function render() {
      var vis = visibleCount();
      index = wrapStart(index, vis);
      var slideW = viewport.clientWidth / vis;
      slides.forEach(function (slide, i) {
        slide.style.flex = '0 0 ' + slideW + 'px';
        slide.style.maxWidth = slideW + 'px';
        var center = index + Math.floor(vis / 2);
        slide.classList.toggle('is-active', i === center);
      });
      track.style.transform = 'translate3d(' + (-index * slideW) + 'px,0,0)';
    }

    function step(dir) {
      index = wrapStart(index + dir, visibleCount());
      render();
    }

    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(render, 120);
    });

    render();
  }

  function boot() {
    document.querySelectorAll('[data-mhm-root]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
